import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import {
  ColumnOrderState,
  OnChangeFn,
  SortingState,
  VisibilityState,
} from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@model/enum/state.enum';

import {
  EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_LIST,
  EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_ORDER,
  EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_VISIBILITY,
} from './emsp-bo-rfid-badge-order-list.config';

interface EmspBoRfidBadgeOrderListViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<BackOfficeRfidBadgeOrderModel>;
  columnVisibility?: VisibilityState;
  columnOrder?: ColumnOrderState;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationPageNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
  renderColumnSettings?: (close: () => void) => React.ReactNode;
  onHideColumn?: (columnId: string) => void;
  onColumnOrderChange?: OnChangeFn<ColumnOrderState>;
}

export const EmspBoRfidBadgeOrderListView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  columnVisibility = EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_VISIBILITY,
  columnOrder = EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_ORDER,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
  renderColumnSettings,
  onHideColumn,
  onColumnOrderChange,
}: EmspBoRfidBadgeOrderListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // LIST //////////////////////////////////////////////////////////////////////

  const columns = useMemo(
    () => [...EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_LIST],
    [],
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable<BackOfficeRfidBadgeOrderModel>
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={columns}
      columnOrder={columnOrder}
      columnVisibility={columnVisibility}
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.emsp-bo-rfid-badge-order-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
      renderColumnSettings={renderColumnSettings}
      onHideColumn={onHideColumn}
      onColumnOrderChange={onColumnOrderChange}
    />
  );
};
